const PENDING_STRIPE_CHARGE_KEY = 'stripe_checkout_pending_charge';

export function buildStripeReturnUrl(slug, origin = window.location.origin) {
  const normalizedSlug = String(slug || '').replace(/^\/+|\/+$/g, '');
  const path = normalizedSlug ? `/${normalizedSlug}/thanks` : '/thanks';

  return `${origin}${path}`;
}

export function hasStripeReturnParams(search = window.location.search) {
  const params = new URLSearchParams(search);

  return params.has('payment_intent_client_secret') || params.has('payment_intent');
}

export function savePendingStripeCharge(chargeId) {
  if (!chargeId) {
    return;
  }

  localStorage.setItem(PENDING_STRIPE_CHARGE_KEY, String(chargeId));
}

export function getPendingStripeCharge() {
  return localStorage.getItem(PENDING_STRIPE_CHARGE_KEY);
}

export function clearPendingStripeCharge() {
  localStorage.removeItem(PENDING_STRIPE_CHARGE_KEY);
}

export { PENDING_STRIPE_CHARGE_KEY };
